import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/images/payment_detail_icon.png'


const _hoisted_1 = { class: "common_layout user_total_layout" }
const _hoisted_2 = { class: "payment_top" }
const _hoisted_3 = { class: "top_paystate" }
const _hoisted_4 = {
  key: 0,
  class: "top_paystate_tips"
}
const _hoisted_5 = {
  key: 0,
  class: "payment_top payment_main_detail",
  style: {"padding":"20px 15px","background":"#ffffff","margin-bottom":"160px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "center_flex_layout",
  style: {"justify-content":"flex-start"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"14px","height":"14px"},
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "detail_title" }, "商品明细")
], -1)
const _hoisted_7 = { style: {"margin-left":"15px","width":"calc(100% - 79px)"} }
const _hoisted_8 = {
  class: "common_font text_hidden",
  style: {"font-size":"12px"}
}
const _hoisted_9 = { style: {"font-size":"11px","color":"rgba(0, 0, 0, 0.4)","margin-top":"8px"} }
const _hoisted_10 = {
  class: "common_font",
  style: {"margin-top":"10px"}
}
const _hoisted_11 = { style: {"font-size":"11px"} }
const _hoisted_12 = { class: "goods_price_plate" }
const _hoisted_13 = {
  class: "center_flex_layout common_font",
  style: {"justify-content":"space-between"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px"} }, "商品总计：", -1)
const _hoisted_15 = { style: {"font-size":"12px","font-weight":"bolder"} }
const _hoisted_16 = { style: {"font-size":"16px"} }
const _hoisted_17 = {
  class: "center_flex_layout",
  style: {"justify-content":"flex-end","padding-top":"20px","border-top":"1px rgba(126, 126, 153, 0.5) dashed"}
}
const _hoisted_18 = { class: "common_font" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "合计：", -1)
const _hoisted_20 = { style: {"font-size":"12px","font-weight":"bolder"} }
const _hoisted_21 = { style: {"font-size":"16px"} }
const _hoisted_22 = {
  key: 1,
  class: "bottom_button_plate"
}
const _hoisted_23 = {
  class: "common_font",
  style: {"text-align":"center","margin-top":"16px"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#292929"} }, "应付金额：", -1)
const _hoisted_25 = { style: {"font-size":"12px","font-weight":"bolder"} }
const _hoisted_26 = { style: {"font-size":"16px"} }

import { reactive, onMounted, getCurrentInstance } from "vue";
import { get, post } from "../../utils/request";
import { Encrypt } from "../../utils/secret";
import { useRouter } from "vue-router";
import { Decrypt } from "../../utils/secret";


export default /*#__PURE__*/_defineComponent({
  __name: 'payingFail',
  setup(__props) {

const router = useRouter();
const { proxy }: any = getCurrentInstance();
const orderDetail = reactive({ value: "" });
const orderNum = reactive({ value: "" });
const payMethod = reactive({ value: "" });
const goodsData = reactive({ value: [] });
const checkoutType = reactive({ value: "" });
const wechatOpenId = reactive({ value: "" });
let checkPayTime;

// orderNum.value = '857970000330';

onMounted(() => {
	//先解码再解密
	if (router.currentRoute.value.query.data) {
		const encodedData = JSON.parse(
			Decrypt(decodeURIComponent(router.currentRoute.value.query.data))
		);
		orderNum.value = encodedData.orderId;
		payMethod.value = encodedData.payMethodType;
		checkoutType.value = encodedData.checkoutTypeVal;
		wechatOpenId.value = encodedData.openId;
	}

	getOrderDetail();

	// 2s调一次支付查询
	checkPayTime = setInterval(() => {
		checkPayState("check");
	}, 2000);
});

// 获取详情
const getOrderDetail = () => {
	get(`/user/order/detail?id=${orderNum.value}`, {})
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code === 1) {
				orderDetail.value = res.result;
				goodsData.value = res.result.detailDtoList;
				setTimeout(() => toPay(), 300);
			}
		})
		.catch((error) => {
			alert(error);
		});
};

// 调取支付平台
const toPay = () => {
	let payParams;

	if (payMethod.value === "WEIXIN") {
		payParams = {
			channelType: payMethod.value,
			id: orderNum.value,
			tradeType: checkoutType.value,
			buyerAccount: wechatOpenId.value,
			returnUrl: "https://api.sancttech.com/?state=" + orderNum.value,
			cancelUrl: "https://api.sancttech.com/?state=" + orderNum.value,
		};
	} else {
		payParams = {
			channelType: payMethod.value,
			id: orderNum.value,
			tradeType: checkoutType.value,
			returnUrl: "https://api.sancttech.com/?state=" + orderNum.value,
			cancelUrl: "https://api.sancttech.com/?state=" + orderNum.value,
		};
	}

	post("/user/pay/init", payParams, {
		"Content-Type": "application/json",
	})
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code === 1) {
				if (payMethod.value === "ALIPAY") {
					alipayPay(res.result);
				} else {
					wechatPay(res.result);
				}
			}
		})
		.catch((error) => {
			alert(error);
		});
};

const alipayPay = (data) => {
	let div = document.createElement("div");
	div.innerHTML = data;
	document.body.appendChild(div);
	setTimeout(() => {
		document.forms[0].submit();
	}, 100);
};

const wechatPay = (payData) => {
	let orderParams = {
		orderId: orderDetail.value.id,
		currency: orderDetail.value.currency,
		orderTotal: orderDetail.value.totalMoney,
	};

	let successParams = encodeURIComponent(Encrypt(JSON.stringify(orderParams)));

	WeixinJSBridge.invoke(
		"getBrandWCPayRequest",
		{
			appId: payData.appId, //公众号ID，由商户传入
			timeStamp: payData.timeStamp, //时间戳，自1970年以来的秒数
			nonceStr: payData.nonceStr, //随机串
			package: payData.package,
			signType: payData.signType, //微信签名方式：
			paySign: payData.paySign, //微信签名
		},
		function (res) {
			if (res.err_msg == "get_brand_wcpay_request:ok") {
				// 使用以上方式判断前端返回,微信团队郑重提示：
				//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
				router.push("/shoppay?orderData=" + successParams);
			}
		}
	);
};

const checkPayState = (type) => {
	let orderParams = {
		orderId: orderDetail.value.id,
		currency: orderDetail.value.currency,
		orderTotal: orderDetail.value.totalMoney,
	};

	let successParams = encodeURIComponent(Encrypt(JSON.stringify(orderParams)));

	get(`/user/pay/query/${orderNum.value}`, {}, false, false)
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code === 1) {
				if (type === "return") {
					toPay();
				} else if (res.result.payState === 2) {
					checkPayTime && clearInterval(checkPayTime);
					router.push("/shoppay?orderData=" + successParams);
				}
			} else {
				if (type === "return") {
					toPay();
				}
				if (res.errorCode == 40048) {
					return;
				}
				proxy.$toast(res.message);
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(orderDetail.value.orderStatus === 0
						? "正在支付中..."
						: orderDetail.value.orderStatus === 4
						? "已退款"
						: "等待中..."), 1),
      (orderDetail.value.orderStatus === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 交易完成后将自动返回 "))
        : _createCommentVNode("", true)
    ]),
    (goodsData.value.length > 0 && orderDetail.value.orderType != 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodsData.value, (goods, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "center_flex_layout main_goods_detail",
              style: {"justify-content":"flex-start"},
              key: index
            }, [
              _createVNode(_component_el_image, {
                class: "goods_main_img",
                src: goods.goodsImg,
                lazy: ""
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(goods.goodsName), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(goods.goodsSpecial) + " x" + _toDisplayString(goods.goodsNum), 1),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(goods.currency === "USD" ? "$" : "¥"), 1),
                  _createElementVNode("span", null, _toDisplayString(goods.goodsPrice), 1)
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, [
                _createTextVNode(_toDisplayString(orderDetail.value.currency === "USD" ? "$" : "¥"), 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(orderDetail.value.goodMoney), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, [
                _createTextVNode(_toDisplayString(orderDetail.value.currency === "USD" ? "$" : "¥"), 1),
                _createElementVNode("span", _hoisted_21, _toDisplayString(orderDetail.value.totalMoney), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (orderDetail.value.orderStatus === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("p", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("span", _hoisted_25, [
              _createTextVNode(_toDisplayString(orderDetail.value.currency === "USD" ? "$" : "¥"), 1),
              _createElementVNode("span", _hoisted_26, _toDisplayString(orderDetail.value.totalMoney), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "bottom_main_button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (checkPayState('return')))
          }, "重新支付")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})